class FitmentGridSorter {
  constructor(grid) {
    this.grid = grid;
    this.sorting = false;
    this.scheduled = false;
    this.sort = this.sort.bind(this);
    this.schedule = this.schedule.bind(this);

    this.observer = new MutationObserver(() => {
      if (this.sorting) {
        return;
      }

      this.schedule();
    });

    this.observer.observe(this.grid, { childList: true });
    this.schedule();
  }

  schedule() {
    if (this.scheduled) {
      return;
    }

    this.scheduled = true;
    const callback = () => {
      this.scheduled = false;
      this.sort();
    };

    if (typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(callback);
    } else {
      window.setTimeout(callback, 0);
    }
  }

  sort() {
    const items = Array.from(this.grid.children);
    if (items.length < 2) {
      return;
    }

    const sortableItems = items.filter((item) => item.dataset.fitmentRank !== undefined);
    if (sortableItems.length < 2) {
      return;
    }

    const normalizeNumber = (value, fallback) => {
      const parsedValue = Number(value);
      return Number.isFinite(parsedValue) ? parsedValue : fallback;
    };

    const sortedSortableItems = [...sortableItems].sort((left, right) => {
      const leftRank = normalizeNumber(left.dataset.fitmentRank, 999);
      const rightRank = normalizeNumber(right.dataset.fitmentRank, 999);
      if (leftRank !== rightRank) {
        return leftRank - rightRank;
      }

      const leftPriority = normalizeNumber(left.dataset.sdgPriority, 10);
      const rightPriority = normalizeNumber(right.dataset.sdgPriority, 10);
      if (leftPriority !== rightPriority) {
        return leftPriority - rightPriority;
      }

      const leftDisplayPrice = normalizeNumber(left.dataset.displayPrice, 0);
      const rightDisplayPrice = normalizeNumber(right.dataset.displayPrice, 0);
      if (leftDisplayPrice !== rightDisplayPrice) {
        return rightDisplayPrice - leftDisplayPrice;
      }

      const leftOrder = normalizeNumber(left.dataset.fitmentOrder, 0);
      const rightOrder = normalizeNumber(right.dataset.fitmentOrder, 0);
      return leftOrder - rightOrder;
    });

    const changed = sortedSortableItems.some(
      (item, index) => item !== sortableItems[index],
    );
    if (!changed) {
      return;
    }

    const nextSortedItems = [...sortedSortableItems];
    const fragment = document.createDocumentFragment();

    this.sorting = true;
    for (const item of items) {
      if (item.dataset.fitmentRank !== undefined) {
        fragment.appendChild(nextSortedItems.shift());
        continue;
      }

      fragment.appendChild(item);
    }

    this.grid.appendChild(fragment);
    this.sorting = false;
  }
}

function initFitmentGridSorter() {
  const grid = document.getElementById("product-grid");
  if (!grid || grid.__fitmentGridSorter) {
    return;
  }

  grid.__fitmentGridSorter = new FitmentGridSorter(grid);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initFitmentGridSorter);
} else {
  initFitmentGridSorter();
}

document.addEventListener("collection:updated", initFitmentGridSorter);
